module.exports = __webpack_public_path__ + "static/media/sierraSedivy.b8ae0c8b.jpeg";